import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractPageComponent, BasePageComponent, NoResultComponent } from '@spike/scaffolds';
import { AsyncApiService, ResourceApiService} from '@spike/core';
import { WalletRecap } from "../../models/wallet-recap.model";
import { Wallet } from "../../models/wallet.model";
import { ButtonGroup } from "primeng/buttongroup";
import { Button } from "primeng/button";

// PrimeNG o altri moduli necessari per la UI
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { WalletRecapComponent } from "../../components/wallet-recap/wallet-racap";
import { WalletSidePanelComponent } from "../../toggle-panels/wallet-side-panel/wallet-side-panel";
import { WalletPieChartComponent } from "../../components/wallet-pie-chart/wallet-pie-chart";

@Component({
  selector: 'spike-wallet-page',
  templateUrl: './wallet-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, BasePageComponent, NoResultComponent, Button, WalletRecapComponent, WalletSidePanelComponent, WalletPieChartComponent],
})
export class WalletPageComponent extends AbstractPageComponent {
  // Inject
  private readonly resourceApi = inject(ResourceApiService);
  private readonly asyncApi = inject(AsyncApiService);

  // Proprietà Statiche / Config
  private readonly walletEntity = EntityApiEnum.FIN_WALLET;
  private readonly walletRecapView = EntityApiEnum.FIN_WALLET_RECAP;
  public readonly breadcrumb = [{label:'Portafogli'}];

  // Local State (Signals)
  public readonly view = signal<number>(1);
  public readonly isSidepanelVisibile= signal<boolean>(false);
  public readonly selectedWallet = signal<Wallet|undefined>(undefined);

  // Resource: caricamento dati reattivo
  public readonly walletRecapResource = this.resourceApi.selectAll<WalletRecap>(signal(this.walletRecapView));

  // Computed State per i grafici: si aggiorna ogni volta che la risorsa cambia
  public readonly wallets = this.walletRecapResource.value;
  

  public async openWalletDialog(finWalletId?: number) {
    let wallet: Wallet|undefined= undefined;
    if(finWalletId){
      wallet = await this.asyncApi.selectById<Wallet>(this.walletEntity, finWalletId);
    }
    this.selectedWallet.set(wallet);
    this.isSidepanelVisibile.set(true);
  }

 
  closeSidePanel(){
    this.isSidepanelVisibile.set(false);
    this.selectedWallet.set(undefined);
  }

  onSave(){
    this.walletRecapResource.reload();

  }
  onDelete(){
    this.walletRecapResource.reload();
    this.closeSidePanel();
  }
}